import { call, select, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { requestCreditCardChange } from '../api/card';
import { getSessionId } from '../selectors/session';
import { doShowLoading, doHideLoading } from '../actions/ui';
import { doSaveLastDigits } from '../actions/session';
import { postMessageSender } from '../lib/postMessager';
import messages from '../enum/messages';

function* handleRequestCreditCardChange(action) {
  yield put(doShowLoading());

  const sessionId = yield select(getSessionId);
  const { m4uEldoradoBridgeRef } = action.payload;

  try {
    const result = yield m4uEldoradoBridgeRef.current.tokenize();
    const { card } = result;
    yield call(requestCreditCardChange, sessionId, card.key, card.cvv);
    yield put(doSaveLastDigits(card.last));
    postMessageSender({ action: 'executed' });
    yield put(push('/sucesso-troca-cartao'));
  } catch (e) {
    if (e.code !== 400) {
      postMessageSender({
        action: 'execute_failed',
        code: 'BE-001',
        reason: messages.FE_001,
      });
      yield put(push('/error'));
    }
  } finally {
    yield put(doHideLoading());
  }
}

export { handleRequestCreditCardChange };
